import React, { FC } from 'react'

import { Translation } from 'cng-common/features/translations/components/translation'
import { Button, IButtonProps } from 'core-components/library/button'

export const CancelButton: FC<IButtonProps> = (props) => {
  return (
    <Button {...props}>
      <Translation text="jbp-cancel" span />
    </Button>
  )
}
